// Links that open a payment app with the amount filled in. No money passes through us.
// Shared by the web page and, later, an SMS agent that texts these links.
// These formats aren't official; check them on a real phone before relying on them.
import { plain } from './money.ts';
import { brand } from './brand.ts';
import type { Cents, Payment } from './types.ts';

export interface PayLink { app: 'venmo' | 'cashapp'; label: string; handle: string; url: string }

export function payLinks(payer: Payment, cents: Cents, note: string): PayLink[] {
  const amount = plain(cents);
  const links: PayLink[] = [];
  if (payer.venmo) {
    links.push({
      app: 'venmo', label: 'Venmo', handle: '@' + payer.venmo,
      url: `https://venmo.com/?txn=pay&recipients=${encodeURIComponent(payer.venmo)}&amount=${amount}&note=${encodeURIComponent(note)}`,
    });
  }
  if (payer.cashapp) {
    links.push({
      app: 'cashapp', label: 'Cash App', handle: '$' + payer.cashapp,
      url: `https://cash.app/$${encodeURIComponent(payer.cashapp)}/${amount}`,
    });
  }
  return links;
}

/**
 * The Venmo note: "Bill split with <our name> <link>". Never the restaurant: a public Venmo feed
 * shouldn't say where someone ate. The link is a "Start a split" link with the payer's code.
 */
export const payNoteWithLink = (link: string): string => `Bill split with ${brand.name} ${link}`;

/** The note that shows in the payer's payment app, e.g. "Lupa Oct 7 · " and our name from src/brand.ts. */
export const payNote = (venue: string, date: string): string => `${venue}${date ? ' ' + date : ''} · ${brand.name}`;

/** Someone marked paying this long ago with no confirmation shows as "Paying? Check your Venmo" to the payer. */
export const PAYING_STALE_MS = 30 * 60_000;
